export const PHENOX_PATENTS = [
  {
    id: 'pct-phenox',
    code: 'PCT',
    title: 'Plataforma PhenoX® de aditivos biobasados',
    status: 'Solicitud activa',
    territories: '7 países, incl. Estados Unidos y Unión Europea',
    family: 'Aditivos inteligentes',
    summary:
      'Solicitud PCT sobre la síntesis y uso de aditivos PhenoX® a partir de biopolímeros de residuos industriales, con protección anticorrosiva y antimicrobiana on-demand.',
    covers: ['PhenoX® Bio-based', 'PhenoX® Bio-based AQ', 'PhenoX® Neorust C65'],
  },
  {
    id: 'pct-neorust',
    code: 'Familia Neorust',
    title: 'Aditivo anticorrosivo libre de cromatos',
    status: 'En preparación / extensión',
    territories: 'Alineada a la familia PCT',
    family: 'Anticorrosivo',
    summary:
      'Respaldo de la composición y el método de incorporación de PhenoX® Neorust C65 en primers y recubrimientos industriales, como alternativa a cromatos.',
    covers: ['PhenoX® Neorust C65'],
  },
  {
    id: 'pct-antimicrobial',
    code: 'Familia Antimicrobial',
    title: 'Superficies con actividad antimicrobiana biobasada',
    status: 'En preparación / extensión',
    territories: 'Alineada a la familia PCT',
    family: 'Antimicrobiano',
    summary:
      'Uso de la plataforma PhenoX® para reducir carga bacteriana en películas de pintura, sustituyendo biocidas convencionales.',
    covers: ['PhenoX® Antimicrobial'],
  },
];

export const PATENT_STATUSES = ['Todas', ...Array.from(new Set(PHENOX_PATENTS.map((item) => item.status)))];

export const IP_FORMULAS = [
  {
    id: 'fx-neorust-c65',
    code: 'FX-NR-C65',
    name: 'Fórmula Neorust C65',
    product: 'PhenoX® Neorust C65',
    secrecy: 'Secreto industrial',
    status: 'Vigente',
    summary:
      'Ruta de síntesis y rangos de dosificación del grado C65 para primers anticorrosivos. No se publica el detalle; solo el registro interno de PI.',
    properties: [
      { label: 'Producto', value: 'PhenoX® Neorust C65' },
      { label: 'Formato', value: 'Polvo' },
      { label: 'Protección', value: 'Secreto industrial + PCT' },
      { label: 'Uso', value: 'Primers y recubrimientos de acero' },
    ],
  },
  {
    id: 'fx-bio-p',
    code: 'FX-BIO-P',
    name: 'Fórmula Bio-based polvo',
    product: 'PhenoX® Bio-based',
    secrecy: 'Secreto industrial',
    status: 'Vigente',
    summary:
      'Composición base de la línea biobasada en polvo: origen de biomasa, condiciones de proceso y ventana de incorporación en formulación.',
    properties: [
      { label: 'Producto', value: 'PhenoX® Bio-based' },
      { label: 'Formato', value: 'Polvo' },
      { label: 'Protección', value: 'Secreto industrial + PCT' },
      { label: 'Uso', value: 'Sistemas solvente y alto sólidos' },
    ],
  },
  {
    id: 'fx-bio-aq',
    code: 'FX-BIO-AQ',
    name: 'Fórmula Bio-based AQ',
    product: 'PhenoX® Bio-based AQ',
    secrecy: 'Secreto industrial',
    status: 'Vigente',
    summary:
      'Suspensión acuosa estable de PhenoX®: medio, sólidos y condiciones de almacenamiento. Registro interno, sin ficha pública de receta.',
    properties: [
      { label: 'Producto', value: 'PhenoX® Bio-based AQ' },
      { label: 'Formato', value: 'Suspensión acuosa' },
      { label: 'Protección', value: 'Secreto industrial + PCT' },
      { label: 'Uso', value: 'Sistemas base agua' },
    ],
  },
  {
    id: 'fx-am',
    code: 'FX-AM',
    name: 'Fórmula Antimicrobial',
    product: 'PhenoX® Antimicrobial',
    secrecy: 'Secreto industrial',
    status: 'Vigente',
    summary:
      'Combinación y carga del aditivo para actividad antibacteriana en película seca, sin biocidas convencionales.',
    properties: [
      { label: 'Producto', value: 'PhenoX® Antimicrobial' },
      { label: 'Formato', value: 'Polvo o suspensión' },
      { label: 'Protección', value: 'Secreto industrial + PCT' },
      { label: 'Uso', value: 'Recubrimientos sanitarios e institucionales' },
    ],
  },
  {
    id: 'fx-nano',
    code: 'FX-NANO',
    name: 'Fórmula Nano',
    product: 'PhenoX® Nano',
    secrecy: 'Secreto industrial',
    status: 'En desarrollo',
    summary:
      'Paquete de nanoaditivos para protección pasiva y ajuste de película. Versión interna de trabajo, aún no congelada.',
    properties: [
      { label: 'Producto', value: 'PhenoX® Nano' },
      { label: 'Formato', value: 'Nanoaditivo' },
      { label: 'Protección', value: 'Secreto industrial' },
      { label: 'Uso', value: 'Ajuste de formulaciones de alto desempeño' },
    ],
  },
];

export const FORMULA_STATUSES = ['Todas', ...Array.from(new Set(IP_FORMULAS.map((item) => item.status)))];
